import {
    HttpTransportType,
    HubConnection,
    HubConnectionBuilder,
    IRetryPolicy,
    LogLevel,
} from "@microsoft/signalr";
import { UNAUTHORIZED_ERROR } from "./SignalRConstants";
import i18n from "src/app/shared/localization/i18n";
import { redirectToLogin } from "src/~store/history";

declare global {
    interface Window {
        signalRHubConnection: HubConnection;
    }
}

export const createSignalRConnection = (hostUrl: string) => {
    console.log("Creating SignalR connection..");

    const userInStorage = sessionStorage.getItem("user");
    const token =
        userInStorage === null
            ? ""
            : JSON.parse(userInStorage.toString()).tokenInfo.token;
    const hubConnection = new HubConnectionBuilder()
        .withUrl(hostUrl + "/chat", {
            accessTokenFactory: () => token,
            transport: HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect({
            nextRetryDelayInMilliseconds: (retryContext: any) => {
                if (
                    retryContext.retryReason.message.includes(
                        UNAUTHORIZED_ERROR
                    )
                ) {
                    logout(i18n.t("error.invalidTokenErrorMessage"));
                }
                if (retryContext.previousRetryCount < 5) {
                    return retryContext.previousRetryCount * 2000;
                } else {
                    return 10000;
                }
            },
        } as IRetryPolicy)
        .configureLogging(LogLevel.Critical)
        .build();

    hubConnection.on("Ping", (pingTime: any) => pong(pingTime));

    hubConnection.onclose((err: any) => {
        const error = err === undefined ? "" : "Error: " + err;
        console.log("Connection closed! " + error);
        if (error.includes(UNAUTHORIZED_ERROR)) {
            logout(i18n.t("error.invalidTokenErrorMessage"));
        }
    });

    window.signalRHubConnection = hubConnection;
    return hubConnection;
};

export const startSignalRConnection = async (hubConnection: HubConnection) => {
    hubConnection.serverTimeoutInMilliseconds = 10000;
    hubConnection.keepAliveIntervalInMilliseconds = 60000;
    console.log("Connecting..");
    try {
        await hubConnection.start();
        console.log("Connection started!");
        return await hubConnection.invoke("CheckOperatorStatus");
    } catch (err: any) {
        console.log("Error while establishing connection: " + err);
        if (err.message.includes(UNAUTHORIZED_ERROR)) {
            logout(i18n.t("error.invalidTokenErrorMessage"));
        }
        setTimeout(() => {
            startSignalRConnection(hubConnection);
        }, 2000);
    }
};

export const logout = (logoutMessage?: string) => {
    sessionStorage.removeItem("user");
    redirectToLogin(
        `${logoutMessage !== undefined ? `${logoutMessage}` : ""}`
    );
};

const pong = (pingTime: Date) => {
    window.signalRHubConnection.send("Pong", pingTime, new Date());
    // console.log(
    //     `[${new Date().toISOString()}] Sent pong ${pingTime} for ${
    //         window.signalRHubConnection.connectionId
    //     }`
    // );
};
